import { Component, Input, Output, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { AddQuestionLevelTimeDirective, ReSizeDirective, OnCreate } from '../app.taketestdirective'
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'
declare var ITEMSCORECultVal: any, ITEMLABLECultVal: any;
@Component({
    selector: 'question-common-component',
    templateUrl: 'app.question.common.html'
})
export class QuestionCommonComponent implements OnInit {
    public ITEMSCORE: any;
    public ITEMLABLE: any;
    //from parent
    @Input() item: any;
    @Input() TestInfo: any;
    @Input() QuesTryout: any;
    // from child
    ngOnInit() {
        try {
            this.AssignResouceKeyValue();
        }
        catch (e) { }
    }
    AssignResouceKeyValue() {
        try {
            this.ITEMLABLE = ITEMLABLECultVal;
            this.ITEMSCORE = ITEMSCORECultVal;
        }
        catch (e) { }
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/QuestionCommon/app.question.common.ts